ch-barcode-scanner {
  display: grid;
  position: relative;
  inline-size: 100%;
  overflow: hidden;
  overflow: clip;
}
ch-barcode-scanner > .ch-barcode-scanner-absolute {
  display: grid;
  align-self: center;
  position: absolute;
  inline-size: 100%;
}